var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("h3", { class: _vm.className, on: { click: _vm.toggleCalendar } }, [
    _c(
      "a",
      { staticClass: "link_setting cal_fold_btn" },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c("span", { staticClass: "ico_cafe ico_arrow" })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }